export default "__VITE_ASSET__uzYh$cvN__"